import camelcaseKeys from 'camelcase-keys';
import snakeCaseKeys from 'snakecase-keys';
import type { Configuration, CreateExpenseRequest, ReportExpenseRequest, ReportVehicleExpenseRequest, UpdateExpenseRequest } from '../..';
import type { Supplier } from '../../__generated__/graphql';
import HttpMethod from '../../request/HttpMethod';
import Requester from '../../request/Requester';
import TimeZone from '../../request/Timezone';
import type { IRequest } from '../../request/Types';

export class TCORequester {
  private requester: Requester;

  constructor(configuration: Configuration) {
    this.requester = new Requester(configuration);
  }

  public createSupplier = async (name: string): Promise<Supplier> => {
    const requestData: IRequest = {
      endpoint: '/v1/expenses/suppliers',
      method: HttpMethod.POST,
      body: JSON.stringify({ name }),
    };

    const result = await this.requester.request(requestData);

    return camelcaseKeys(result.data, { deep: true }) as Supplier;
  };

  public createExpense = async (createRequest: CreateExpenseRequest): Promise<void> => {
    const requestData: IRequest = {
      endpoint: '/v1/expenses',
      method: HttpMethod.POST,
      body: JSON.stringify(snakeCaseKeys(createRequest)),
    };

    await this.requester.request(requestData);
  };

  public deleteExpense = async (id: string): Promise<void> => {
    const requestData: IRequest = {
      endpoint: `/v1/expenses/${id}`,
      method: HttpMethod.DELETE,
    };

    await this.requester.request(requestData);
  };

  public updateExpense = async (id: string, updateRequest: UpdateExpenseRequest): Promise<void> => {
    const requestData: IRequest = {
      endpoint: `/v1/expenses/${id}`,
      method: HttpMethod.PATCH,
      body: JSON.stringify(snakeCaseKeys(updateRequest)),
    };

    await this.requester.request(requestData);
  };

  public requestReport = async (reportRequest: ReportExpenseRequest): Promise<void> => {
    const requestData: IRequest = {
      endpoint: '/analytics/v1/expense/report/mail',
      method: HttpMethod.POST,
      body: JSON.stringify(snakeCaseKeys({ ...reportRequest, timezone: TimeZone.getTimezone() })),
    };

    await this.requester.request(requestData);
  };

  public requestVehicleReport = async (reportRequest: ReportVehicleExpenseRequest): Promise<void> => {
    const requestData: IRequest = {
      endpoint: '/analytics/v1/expense/vehicle/report/mail',
      method: HttpMethod.POST,
      body: JSON.stringify(snakeCaseKeys({ ...reportRequest, timezone: TimeZone.getTimezone() })),
    };

    await this.requester.request(requestData);
  };

  public expensesExists = async (): Promise<boolean> => {
    const requestData: IRequest = {
      endpoint: '/v1/expenses/exists',
      method: HttpMethod.GET,
    };

    const result = await this.requester.request(requestData);

    return result.data as boolean;
  };
}

export default TCORequester;
